export const FILTERS_COMPONENTS_TRANSLATION_NAMESPACE = "filters-components";

export const COMPARE_KEY_DIALOG_TK = "COMPARE_KEY_DIALOG_TK";

export const TIMESLOT_FILTER_TK = "TIMESLOT_FILTER_TK";

export const DISTANCE_FILTER_TK = "DISTANCE_FILTER_TK";
